import React from 'react';
import PropTypes from 'prop-types';
import { getSocialIcon } from '@launchmetrics/lm-icons';

function VoiceRelations({ variant = "plain", color = "", ...props }) {
	let { type, size } = props;

	if (type === "wechat_public") {
		type = "wechat";
    }

	const Icon = getSocialIcon(type, variant);
	if (!Icon) return;
	return <Icon style={{fontSize: size, color: color}} />;

}

VoiceRelations.propTypes = {
	variant: PropTypes.string,
	type: PropTypes.string.isRequired,
	size: PropTypes.string
}

export default VoiceRelations;
